import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Image } from 'components/core/Image';
import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';

import './PSPList.scss';

export function PSPListElement({ content, orderedStep, icon, src }) {
	return (
		<li className={classnames('psp-list-element', { short: content.length <= 100 })}>
			{!!orderedStep && (
				<span className="step-number">{orderedStep}</span>
			)}
			{!!src && (
				<Image src={src} alt="" aria-hidden />
			)}
			{!!icon && (React.createElement(icon))}
			<div>
				<PSPMarkdownContent content={content} />
			</div>
		</li>
	);
}

export default function PSPList({ content, ordered }) {
	return (
		<PSPModuleWrapper className="psp-list">
			{ordered ? (
				<ol>
					{content.map((item, index) => (
						<PSPListElement
							key={item.text}
							content={item.text}
							orderedStep={index + 1}
						/>
					))}
				</ol>
			) : (
				<ul>
					{content.map((item) => (
						<PSPListElement
							key={item.text}
							content={item.text}
							icon={item.icon}
							src={item.src}
						/>
					))}
				</ul>
			)}
		</PSPModuleWrapper>
	);
}

PSPListElement.propTypes = {
	content: PropTypes.string.isRequired,
	icon: PropTypes.func,
	orderedStep: PropTypes.number,
	src: PropTypes.string
};

PSPList.propTypes = {
	content: PropTypes.arrayOf(PropTypes.object).isRequired,
	ordered: PropTypes.bool
};
